import { EventEmitter } from 'events';
import Dispatcher from '../dispatcher';
import Config from '../config/config';
import md5 from 'md5';

class Login extends EventEmitter {
  goPreLogin(data) {
    fetch(Config.configURL().PreLoginURL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data.text),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.Result.Status === 'SUCCESS') {
          if (!responseJson.isPropertyADAuthenticated) {
            data.text.Password = md5(data.text.Password);
          }
          this.goLogin(data);
        }
      })
      .catch((err) => {
        document.getElementById('btnSigning').style.display = 'none';
        document.getElementById('buttonsign').style.display = 'inline';
        document.getElementById('loginError').style.display = 'block';
        document.getElementById('loginErrorMsg').innerHTML = '';
      });
  }

  goLogin(data) {
    if (localStorage.loginFailCount > 3) {
      if (localStorage.captchaTextUser !== data.text.captchaTextVal) {
        document.getElementById('loginError').style.display = 'block';
        document.getElementById('loginErrorMsg').innerHTML = 'Invalid Captcha';
        this.createImage();
        return false;
      }
    }

    fetch(Config.configURL().LoginURL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data.text),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.Result.Status === 'FAILED') {
          document.getElementById('btnSigning').style.display = 'none';
          document.getElementById('buttonsign').style.display = 'inline';
          document.getElementById('loginError').style.display = 'block';
          document.getElementById('loginErrorMsg').innerHTML =
            responseJson.Result.Message;
          if (localStorage.loginFailCount) {
            localStorage.loginFailCount =
              Number(localStorage.loginFailCount) + 1;
          } else {
            localStorage.loginFailCount = 1;
          }

          if (localStorage.loginFailCount > 3) {
            this.createImage();
          }
        } else {
          localStorage.loginFailCount = 0;
          var token = responseJson.Response.Token;
          // for build:
          var path = responseJson.Response.ZoneUrlKIHTML;

          // for dev:
          // var path = 'http://localhost:3001' + '/#/?=' + token;
          // var path = 'http://local-core.knowcross.com';

          var dateP = new Date();
          var Domain = Config.configURL().Domain;
          var secureDomain = Config.secureDomain() || {};
          var secureFlag = secureDomain.cookie ? '; secure=true' : '';
          var sameSiteFlag = '; SameSite=Lax';
          var dateP1 = dateP.getTime() + 31 * 24 * 60 * 60 * 1000;
          dateP.setTime(dateP1);

          var expiresP = dateP.toUTCString();
          var cookieString =
            'INSToken=' +
            token +
            '; expires=' +
            expiresP +
            '; path=/; domain=' +
            Domain +
            secureFlag +
            sameSiteFlag;
          // secureFlag; +
          document.cookie = cookieString;

          setTimeout(function () {
            window.location.href = path;
          }, 1000);
          return false;
        }
      });
  }

  handleAction(action) {
    switch (action.type) {
      case 'Login_fetch': {
        this.goLogin(action.text);
        break;
      }
      default:
    }
  }
  createImage() {
    document.getElementById('captchaMainDiv').style.display = 'block';
    document.getElementById('canvasDiv').innerHTML = '';
    const cap = '<canvas id="mycanvas" class="captchaDefault"> </canvas> ';
    //cap +='<input class="form-control" placeholder="Enter Text" ng-model="capchaText" name="capcha" type="capcha" value="" id="textCapcha">  <span class="capError"></span>';
    document.getElementById('canvasDiv').innerHTML = cap;
    const canvasT = document.getElementById('mycanvas');
    const ctx = canvasT.getContext('2d');
    const textToImage = this.alphanumeric_unique();
    localStorage.captchaTextUser = textToImage;
    ctx.font = '70px Arial';
    ctx.fillStyle = '#fff';
    ctx.fillText(textToImage, 60, 100);
    document.getElementById('captchaText').value = '';
    document.getElementById('btnSigning').style.display = 'none';
    document.getElementById('buttonsign').style.display = 'inline';
  }
  alphanumeric_unique() {
    return Math.random()
      .toString(36)
      .split('')
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      })
      .join('')
      .substr(2, 4);
  }
}

const login = new Login();
Dispatcher.register(login.handleAction.bind(login));
export default login;



// WEBPACK FOOTER //
// ./src/stores/stores.js